import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AllBidsService {

    constructor(private _http: HttpClient) { }

    getproductbidlisting(data) {
        return this._http.post(environment.api_url+'seller/bids/alllisting',data);
    }

    getbidmylisting(data) {
        return this._http.post(environment.api_url+'seller/bids/mylisting',data);
    }

    getbidinfo(data) {
        return this._http.post(environment.api_url+'seller/bids/info',data);
    }

    acceptbid(data) {
        return this._http.post(environment.api_url+'seller/bids/accept',data);
    }

    declinebid(data) {
        return this._http.post(environment.api_url+'seller/bids/decline',data);
    }

    savecounteroffer(data){
        return this._http.post(environment.api_url+'seller/bids/counteroffer',data);
    }

}
